import { useEffect, useRef } from 'react';
export default function useOverlayFocus(open, onClose) {
    const ref = useRef(null);
    const close = useRef(onClose);
    close.current = onClose;
    useEffect(() => {
        if (!open || !ref.current) return;
        const previous = document.activeElement;
        const overflow = document.body.style.overflow;
        const overlay = ref.current;
        const main = document.getElementById('main-content');
        // Existing overlays live inside main, so trap focus without making main inert.
        document.body.style.overflow = 'hidden';
        const focusable = () => Array.from(overlay.querySelectorAll('button,a[href],input,textarea,select,video[controls],[tabindex="0"]')).filter(element => !element.disabled && element.getClientRects().length);
        (focusable()[0] || overlay).focus();
        const handler = event => {
            if (event.key === 'Escape') { event.preventDefault(); close.current(); }
            if (event.key === 'Tab') {
                const items = focusable();
                const first = items[0], last = items[items.length - 1];
                if (!first) { event.preventDefault(); overlay.focus(); }
                else if (event.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
                else if (!event.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
            }
        };
        document.addEventListener('keydown', handler);
        return () => { document.removeEventListener('keydown', handler); document.body.style.overflow = overflow; if (main && previous?.isConnected) previous.focus(); };
    }, [open]);
    return ref;
}
